'use client';

import clsx from 'clsx';
import { Menu } from 'lib/shopify/types';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

const FooterMenuItem = ({ item }: { item: Menu }) => {
  const pathname = usePathname();
  const [active, setActive] = useState(pathname === item.path);

  useEffect(() => {
    setActive(pathname === item.path);
  }, [pathname, item.path]);

  item.path = item.path.replace('https://madeforhue.com', '');
  return (
    <li className={'mb-1'}>
      <Link
        href={item.path}
        className={clsx('hover:text-hue-primary inline-block text-xs font-bold text-hue-white', {
          'text-black dark:text-neutral-300': active
        })}
      >
        {item.title}
      </Link>
    </li>
  );
};

export default function FooterMenu({ menu}: { menu: Menu[]; title: string }) {
  if (!menu.length) return null;

  return (
    <nav>
      <ul>
        {menu.map((item: Menu) => {
          return <FooterMenuItem key={item.title} item={item} />;
        })}
      </ul>
    </nav>
  );
}
